<div class="main">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="title">
          <span style="float: left; padding: 2px">
            {{ "REPORTS.title" | translate }}
          </span>
        </div>
      </div>
      <div class="header" *ngIf="epodStatus">
        <div class="title">
          <span style="float: left; padding: 2px">
            {{ "REPORTS.epodTitle" | translate }}
          </span>
        </div>
      </div>
      <div class="bodySection">
        <div class="mainFilter">
          <div class="filter">
            <div class="label">
              {{ "REPORTS.reportType" | translate }} <span><sup class="required">*</sup></span>
            </div>
            <div class="input">
              <!-- <mat-select class="inputSelect" [(ngModel)]="reportRequest.url" style="color: #fff">
                <mat-option *ngFor="let report of reportTypes" [value]="report.value"
                  (onSelectionChange)="selectType(report, $event);">
                  {{ report.name }}
                </mat-option>
                <mat-divider></mat-divider>
              </mat-select> -->
              <mat-select class="inputSelect" [(ngModel)]="reportRequest.url" style="color: #fff">
                <mat-optgroup *ngFor="let group of reportTypes">
                  <span>
                    <!-- {{group.name}}  -->
                    {{ ('REPORTS.' + group.name) | translate }}
                  </span>
                  <mat-option *ngFor="let report of group.groupValues" [value]="report.value"
                    (onSelectionChange)="selectType(report, $event);">
                    <!-- {{report.name}} -->
                    {{ ('REPORTS.' + report.name) | translate }}
                  </mat-option>
                </mat-optgroup>
                <mat-divider></mat-divider>
              </mat-select>
            </div>
          </div>
          <div class="header-1" *ngIf="nonPlacement">
            <div class="title">
              <span style="float: left; padding: 2px;color:red;margin-top: 16px;">
                Note:- {{ "REPORTS.selectAllShipper" | translate }}
              </span>
            </div>
          </div>
          <div class="filter" *ngIf="!onlyFromTo && !epodStatus && !nonPlacement && !consent">
            <div class="label" style="width: 50%;">
              {{ "REPORTS.shipperOnly" | translate }}
            </div>
            <div class="input" style="width: 50%;">
              <mat-slide-toggle [disabled]="!reportRequest.url" (change)="selectedShipperOnly=!selectedShipperOnly;">
              </mat-slide-toggle>
              <mat-hint style="display: block; font-size:10px; padding:3px">
                {{ "REPORTS.shipperOnlyHint" | translate }}
              </mat-hint>
            </div>
          </div>
  
        </div>
  
        <div class="form">
          <div class="datepickers">
            <div class="filter" *ngIf="!epodStatus">
              <div class="label">
                {{ "REPORTS.from" | translate }} <span><sup class="required">*</sup></span>
              </div>
              <div class="input">
                <input type="text" style="width: 40%" class="inputField"
                  placeholder="Date" [(ngModel)]="fromDate" (click)="fromDateInput.open()"
                  [matDatepicker]="fromDateInput" />
                <mat-datepicker #fromDateInput></mat-datepicker>
                <span class="material-icons dateIcon"> date_range </span>
              </div>
            </div>
            <div class="filter" *ngIf="!epodStatus">
              <div class="label">
                {{ "REPORTS.to" | translate }} <span><sup class="required">*</sup></span>
              </div>
              <div class="input">
                <input type="text" [disabled]="!reportRequest.url" style="width: 40%" class="inputField"
                  placeholder="Date" [(ngModel)]="toDate" (click)="toDateInput.open()" [matDatepicker]="toDateInput" />
                <mat-datepicker #toDateInput></mat-datepicker>
                <span class="material-icons dateIcon"> date_range </span>
              </div>
            </div>
  
            <div class="filter" *ngIf="showPickDrop && !onlyFromTo && !consent">
              <div class="label">
                {{ "REPORTS.pickup" | translate }}
              </div>
              <div class="input">
                <mat-select class="inputSelect" multiple [(ngModel)]="selectedPickups" style="color: #fff"
                  [disabled]="!reportRequest.url">
                  <input style="width: 95%;margin: 4px;" class="searchInput" [(ngModel)]="filterFrom" />
                  <mat-option *ngFor="let location of locationsArray | search: filterFrom:'loc'" [value]="location">
                    <span style="font-weight: bold">{{ location.name }}</span> -
                    {{ location.area }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
  
            <div class="filter" *ngIf="showPickDrop && !onlyFromTo && !epodStatus && !consent">
              <div class="label">
                {{ "REPORTS.drop" | translate }}
              </div>
              <div class="input">
                <mat-select class="inputSelect" multiple [(ngModel)]="selectedDeliveries" style="color: #fff"
                  [disabled]="!reportRequest.url">
                  <input style="width: 95%;margin: 4px;" class="searchInput" [(ngModel)]="filterTo" />
                  <mat-option *ngFor="let location of locationsArray | search: filterTo:'loc'" [value]="location">
                    <span style="font-weight: bold">{{ location.name }}</span> -
                    {{ location.area }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
            <div class="filter" *ngIf="onlyFromTo || nonPlacement">
              <div class="label">
                {{ "REPORTS.shipper" | translate }}
              </div>
              <div class="input">
                <mat-select class="inputSelect" style="width: 184%;" [disabled]="!reportRequest.url" [(ngModel)]="selectShipper">
                  <mat-option *ngFor="let shipper of allShippers" [value]="shipper" (click)="selectedShipper(shipper)">
                    {{shipper.reference}} {{ shipper.parentName }} <span *ngIf="shipper.name">- {{ shipper.name }}</span>
                  </mat-option>
                </mat-select>
              </div>
            </div> 
          </div>
          <div class="datepickers" style="margin-top: 1%;" *ngIf="!onlyFromTo">
            <div class="filter" *ngIf="reportRequest.url == 'epods_carrier'">
              <div class="label">
                {{ "REPORTS.statusType" | translate }}
              </div>
              <div class="input">
                <mat-select class="inputSelect" [disabled]="!reportRequest.url" [(ngModel)]="epodReportStatus"
                  style="color: #fff">
                  <mat-option *ngFor="let status of reportStatus" [value]="status.value"
                    (onSelectionChange)="selectStaus(status, $event);">
                    {{ status.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
  
          </div>
        </div>
        <div class="submitButton">
          <div class="button" (click)="generateReport()">
            {{'REPORTS.generateReport' | translate}}
          </div>
          <div class="button" (click)="resetAll()">
            {{'REPORTS.clear' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>